<template lang="pug">
div.wrap-item-drawing-sub-header.fixed.w-full
  div.item-drawing-sub-header-content.f.flex-between
    div.f.fm
      v-icon(@click="redo").mr2 mdi-redo-variant
      v-icon(@click="undo").mr2 mdi-undo-variant
    div.f.fm
      div.f.fm.mr20
        v-icon(v-for="tool in tools" :key="tool.name"
          :color="tool.name == currentTool ? pallete.$active_color : pallete.$deactive_color"
          @click="onTool(tool.name)").mr4 {{tool.icon}}
      div.line-width-picker.mr4
        v-menu(offset-y)
          template(v-slot:activator="{ on }")
            v-icon(v-on="on" color="black") mdi-format-line-weight
          template
            div.wrap-line-weight-slider.px4.py4
              div.drawing-line-weight-slider
                v-slider(v-model="strokeWeightValue"
                  @change="changeStrokeWeight"
                  min="0.0" max="6.0" step="0.1" vertical)
              div.f.fh.pb10
                div(:style="strokeCircleStyle").stroke-circle
      div.color-picker
        v-menu(offset-y)
          template(v-slot:activator="{ on }")
            //- div(v-on="on"
              :style="`background: ${color};`").stroke-color-circle.cursor-pointer.px9.py9
            div.w24.h24
              v-icon(v-on="on" :color="color" size="24") mdi-water
          template
            div.wrap-drawing-stroke-colors.px4.py4
              div(v-for="color in colors"
                :style="`background: ${color};`"
                @click="onColorPallete(color)").stroke-color-circle.cursor-pointer.px12.py12.mb4
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-drawing-sub-header {
  height: $sub_header_height;
  top: $header_height;
  z-index: 99;
  background: $primary_bg_color;
  box-shadow: $box_shadow_header;
  border-top: $basic_border;
  border-bottom: $basic_border;
  .item-drawing-sub-header-content {
    margin: 0 auto;
    width: $base_width_percent; height: 100%;
    max-width: $base_max_width_px;
    // .line-width-picker {
    //   .wrap-line-weight-slider {
    //     width: 240px;
    //   }
    // }
    .color-picker {
      .stroke-color-circle {
        border: solid 1px $secondary_active_color;
        border-radius: 50%;
      }
    }
  }
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";

.wrap-line-weight-slider {
  .drawing-line-weight-slider {
    // width: 240px;
  }
  .stroke-circle {
    border: solid 1px $secondary_active_color;
    border-radius: 50%;
  }
}

.wrap-drawing-stroke-colors {
  .stroke-color-circle {
    border: solid 1px $secondary_active_color;
    border-radius: 50%;
  }
}
</style>

<script>
export default {
  props: {
    currentTool: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    // strokeWeight: {
    //   type: Number,
    //   required: true
    // }
  },
  computed: {
    strokeCircleStyle () {
      return `width: ${this.strokeWeightValue}px;`
        + `height: ${this.strokeWeightValue}px;`
        + `background: ${this.color};`
    }
  },
  data () {
    return {
      tools: [
        { name: 'pencil', icon: 'mdi-pencil' },
        { name: 'straightLine', icon: 'mdi-vector-line' },
        { name: 'eraser', icon: 'mdi-eraser' }
      ],
      strokeWeightValue: 1.0,
      colors: ['#000000', '#b2b2b2', '#ffffff']
    }
  },
  methods: {
    undo () {
      this.$emit('redo')
    },
    redo () {
      this.$emit('undo')
    },
    onTool (tool) {
      this.$emit('setCurrentTool', tool)
    },
    changeStrokeWeight () {
      this.$emit('setStrokeWeight', this.strokeWeightValue)
    },
    onColorPallete (color) {
      this.$emit('setColor', color)
    }
  }
}
</script>
